import { render } from "./Com_Ani.vue?vue&type=template&id=520407ba&scoped=true"
import script from "./Com_Ani.vue?vue&type=script&lang=js"
export * from "./Com_Ani.vue?vue&type=script&lang=js"

import "./Com_Ani.vue?vue&type=style&index=0&id=520407ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520407ba"]])

export default __exports__